import { render, staticRenderFns } from "./AccordionContent.vue?vue&type=template&id=0647546d&"
import script from "./AccordionContent.vue?vue&type=script&lang=js&"
export * from "./AccordionContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports